import { Button, ButtonLink, Card, ListLayout } from '@ingrid/luterkort-react';
import { ShippingLogo } from '@ingrid/react-shipping-logo';

import { ClearConfirmationModal } from '~src/components/ClearConfirmationModal/ClearConfirmationModal';
import { useTranslation } from '~src/i18n/use-translation';
import { CarrierProductAddons, formatAddonTitle } from '~src/pages/shipment/create/carrier-product-addons';

import { useTemplateFormContext } from '../types';
import { CarrierProductSelect, CarrierProductSelectProps } from './carrier-product-select';

export function CarrierProduct() {
  const { watch, setValue } = useTemplateFormContext();
  const { t } = useTranslation();

  const [shipping_method, addons] = watch(['shipping_method', 'addons']);

  const selectProps: Omit<CarrierProductSelectProps, 'trigger'> = {
    mode: 'add',
    value: {
      shipping_method,
    },
    onSubmit: values => {
      setValue('shipping_method', values.shipping_method, { shouldDirty: true });

      if (shipping_method?.id !== values.shipping_method?.id) {
        setValue('addons', undefined);
      }
    },
  };
  return (
    <Card.List>
      <Card.Wrapper as="section">
        <Card.Header>{t('common.carrierProduct')}</Card.Header>
        <Card.Content>
          {shipping_method ? (
            <ListLayout.Column>
              <ListLayout.Row>
                <ShippingLogo method={shipping_method.id} width="40" />

                <ListLayout.Stack>
                  <ListLayout.PrimaryText>{shipping_method.carrier}</ListLayout.PrimaryText>
                  <ListLayout.SecondaryText>{shipping_method.name}</ListLayout.SecondaryText>
                </ListLayout.Stack>

                <ListLayout.Actions>
                  <CarrierProductAddons
                    trigger={({ disabled }) => <ButtonLink disabled={disabled}>{t('common.addons')}</ButtonLink>}
                    onSubmit={addons => setValue('addons', addons, { shouldDirty: true })}
                    value={addons}
                  />

                  <CarrierProductSelect
                    trigger={<ButtonLink>{t('common.edit')}</ButtonLink>}
                    {...selectProps}
                    mode="update"
                  />

                  <ClearConfirmationModal
                    clearedItemName={`common.carrierProduct`}
                    onSubmit={() => {
                      setValue('shipping_method', undefined);
                      setValue('addons', undefined);
                    }}
                  />
                </ListLayout.Actions>
              </ListLayout.Row>
            </ListLayout.Column>
          ) : (
            <CarrierProductSelect
              trigger={<Button variant="secondary">{t('common.selectCarrierProduct')}</Button>}
              {...selectProps}
            />
          )}
        </Card.Content>

        {addons && addons.length > 0 && (
          <Card.Content>
            <ListLayout.Stack>
              <ListLayout.PrimaryText>{t('common.addons')}</ListLayout.PrimaryText>
              <ListLayout.SubRow gap="lg">
                {addons.map(addon => (
                  <ListLayout.SecondaryText key={addon.code}>{formatAddonTitle(addon)}</ListLayout.SecondaryText>
                ))}
              </ListLayout.SubRow>
            </ListLayout.Stack>
          </Card.Content>
        )}
      </Card.Wrapper>
    </Card.List>
  );
}
